import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useMoodleV2 } from "../../../contexts/moodle";
import DownloadIcon from "@mui/icons-material/Download";
import { useTheme } from "../../../contexts/ThemeContext";
import { readableColor } from "polished";
import { useAuth } from "../../../contexts/AuthContext";
import { useConfig } from "../../../contexts/config";
import { requestAutoLogin } from "../../../services/moodle/userauth";

// cambio
export const ProgressRowItem = ({ course, grade, lang, includeEncuesta }) => {
  const navigation = useNavigate();
  const moodlev2 = useMoodleV2();
  const theme = useTheme();
  const [contrastColor, setContrastColor] = React.useState("#fff");
  const currentRequestId = useRef(0);

  const [data /* setData */] = React.useState({
    name: course.displayname,
    start: new Date(course.startdate * 1000).toLocaleDateString(),
    end: course.enddate !== 0 ? new Date(course.enddate * 1000).toLocaleDateString() : "Sin fecha de termino",
  });
  const [certificadoAvailable, setCertificadoAvailable] = React.useState(null);
  const { user } = useAuth();
  console.log("user: ", user);
  const { config } = useConfig();

  useEffect(() => {
    const fetchCerts = async () => {
      let courseContent = await moodlev2.getCourseContentByID(course.id);
      console.log("courseContent: ", courseContent);
      // recorrer el course content y buscar el modulo que tenga certificado
      courseContent.modules &&
        courseContent.modules.forEach((module) => {
          if (module.modules && module.modules.length > 0) {
            module.modules.forEach(async (submodule) => {
              // si el modulo tiene el prefijo cert y es visible para el usuario
              if (submodule.name.toLowerCase().startsWith("cert") && submodule.uservisible) {
                console.log(submodule);
                await new Promise((resolve) => setTimeout(resolve, 400));
                setCertificadoAvailable(`${submodule.id}`);
              }
            });
          }
        });
    };
    fetchCerts();
  }, [course.id]);

  useEffect(() => {
    if (theme && theme.colors?.background_primary) {
      if (theme.mode === "light") {
        setContrastColor("#232323");
      } else {
        setContrastColor(readableColor(theme.colors?.background_primary?.backgroundColor));
      }
    }
    //console.log(contrastColor)
  }, [theme, contrastColor]);

  const handleDetailNavigation = () =>
    navigation(`/listcourses/progress/${course.id}`, {
      state: { name: data.name },
    });

  const handleCourseNavigation = async () => {
    if (!certificadoAvailable || moodlev2.isDownloading) return;

    moodlev2.setIsDownloading(true);

    try {
      const requestId = ++currentRequestId.current;

      let url;

      let { key } = await requestAutoLogin({
        username: user.username,
        baseUrl: config.baseURL,
        tipddytoken: config.token,
      });

      await new Promise((resolve) => setTimeout(resolve, 400));
      if (requestId === currentRequestId.current) {
        // TODO: Agregar campo administrable para URL API
        url = `https://api-interfaz-alumnos.tipddy.cl/history/cert/${certificadoAvailable}?userid=${user.id}&domain=${encodeURIComponent(config.baseURL)}&userkey=${key}`;
        window.open(url, "_blank", "noopener,noreferrer");
      } else {
        console.log("Solicitud antigua ignorada");
      }
    } finally {
      await new Promise((resolve) => setTimeout(resolve, 400));
      moodlev2.setIsDownloading(false);
    }
  };

  return (
    <>
      <tr
      // className="hover:bg-slate-100"
      >
        <th
          onClick={handleDetailNavigation}
          scope="row"
          className="p-4 border-b cursor-pointer border-slate-200 hover:!text-red-800 transition-colors"
          style={{
            borderColor: theme.colors.backgroundColorNotCurrentModule + 33,
          }}
        >
          <p style={{ color: theme.colors.textColorDefault }}>{data.name}</p>
        </th>
        <td className="p-4 border-b border-slate-200" style={{ borderColor: theme.colors.backgroundColorNotCurrentModule + 33 }}>
          {grade}
        </td>
        {/* <td className="p-4 border-b border-slate-200" style={{ borderColor: theme.colors.backgroundColorNotCurrentModule + 33 }}>
          {data.start}
        </td>
        <td className="p-4 border-b border-slate-200" style={{ borderColor: theme.colors.backgroundColorNotCurrentModule + 33 }}>
          {data.end === "Sin fecha de termino" ? lang["History"].fourth_column_answer : data.end}
        </td> */}
        {/* <td
          className={`p-4 border-b border-slate-200 ${certificadoAvailable && "hover:bg-red-800"}`}
          style={{
            cursor: certificadoAvailable && !moodlev2.isDownloading ? "pointer" : "not-allowed",
            fontWeight: certificadoAvailable ? 700 : 500,
            borderColor: theme.colors.backgroundColorNotCurrentModule,
          }}
          onClick={certificadoAvailable && !moodlev2.isDownloading ? handleCourseNavigation : null}
        >
          {certificadoAvailable ? (
            <div className="flex">
              <DownloadIcon />
              {lang["History"].fifth_column_answer}
            </div>
          ) : (
            "-"
          )}
        </td> */}
        {includeEncuesta && (
          <td className="p-4 border-b border-slate-200" style={{ borderColor: theme.colors.backgroundColorNotCurrentModule +33 }}>
            {" "}
            - {/* {lang["History"].sixth_column_answer} */}
          </td>
        )}
      </tr>
    </>
  );
};
